let Vue = require('vue/dist/vue.js');

import BootstrapVue from "bootstrap-vue";
import Vuelidate from "vuelidate";
import vSelect from 'vue-select';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta'

// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@fortawesome/fontawesome-free/js/fontawesome'
import '@fortawesome/fontawesome-free/js/all'

Vue.config.devtools = true;

Vue.use(VueMeta);
Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.component('v-select', vSelect);

import TravelFlow from './components/TravelFlow';
import store from './store';

require('./bootstrap');
import "tailwindcss/tailwind.css"
import TravelCoverage from "./components/TravelCoverage";
import TravelQuotations from "./components/TravelQuotations";
import TravelPersonalData from "./components/TravelPersonalData";
import TravelAuth from "./components/TravelAuth";

require('slick-carousel/slick/slick.min')

const app = new Vue({

});

document.addEventListener("DOMContentLoaded", function() {
    var elements = document.getElementsByTagName("INPUT");

    for (var i = 0; i < elements.length; i++) {
        elements[i].oninvalid = function(e) {
            e.target.setCustomValidity("");
            if (!e.target.validity.valid) {
                var message = 'Te rugăm să completezi acest câmp';

                if('email' == e.target.getAttribute('type')){
                    message = 'Trebuie să completezi o adresă validă de email.'
                }
                e.target.setCustomValidity(message);
            }
        };
        elements[i].oninput = function(e) {
            e.target.setCustomValidity("");
        };
    }
});

const routes = [
    {
        path: '/asigurare-de-calatorie',
        component: TravelFlow
    },
    {
        path: '/asigurare-de-calatorie/calatori-si-acoperire',
        component: TravelCoverage
    },
    {
        path: '/asigurare-de-calatorie/oferte',
        component: TravelQuotations
    },
    {
        path: '/asigurare-de-calatorie/datele-calatorilor',
        component: TravelPersonalData
    },
    {
        path: '/asigurare-de-calatorie/autentificare',
        component: TravelAuth
    }
];
const router = new VueRouter({
    mode: 'history',
    routes
});

if (document.getElementById('travel')) {
    let vue = new Vue({
        store: store,
        router,
        components: {
            TravelFlow
        },
        render: h => h(TravelFlow)
    }).$mount("#travel")
}
